module.exports = __webpack_public_path__ + "img/firefighter_main2.2724eb42.jpg";